import Filters, { FiltersProps } from './Filters';
import type { FiltersMap } from './types';

export type { FiltersMap, FiltersProps };
export default Filters;
